// extracted by mini-css-extract-plugin
export var cartContainer = "_oh-4";
export var gray = "_oh-1";
export var itemContainer = "_oh-2";
export var itemDetails = "_oh-3";
export var strong = "_oh-0";